// extracted by mini-css-extract-plugin
export default {"wrapper":"Application_wrapper_bCzZU"};